<template>
  <div>
    <div id="panelChart9" class="panel panel-default">
      <dismissable-alert
        :isShowing="isShowingReinvestmentNotice"
        title="Please take note!"
        subtitle="Transactions reinvested at the same rate/term on the same day will be reinvested together into one Note."
        notice=" Transactions that do not amount to $20 or greater when combined will be repaid to the default destination."
        alertType="warning"
        :showIcon="true"
        icon="calendar-payment"
        :dismissible="false"
      />
      <div class="panel-title top-margin bottom-margin">Upcoming transactions</div>

      <div class="row" v-if="isExtraReinvestmentsEnabled">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-12 subtitle">
              <div class="panel-heading">
                <h3 class="panel-title"><em class="fa fa-exchange text-blue"></em>Additional reinvestments</h3>
              </div>
            </div>
          </div>

          <div v-if="!hasAdditionalReinvestments">
            <div class="row top-margin">
              <div class="col-md-12">
                <p class="no-transactions">
                  No additional reinvestments at the moment.
                </p>
              </div>
            </div>
          </div>

          <div v-if="hasAdditionalReinvestments" class="table-responsive top-margin">
            <table class="table table-striped additional-reinvestments-table">
              <thead>
                <tr>
                  <th class="text-right">Amount</th>
                  <th class="text-center">Reinvestment Date</th>
                  <th class="text-center">Funding Source</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ar, index) in additionalReinvestments" :key="index">
                  <td class="text-right">{{ formatAmount(Number(ar.amount)) }}</td>
                  <td class="text-center">{{ formatDate(ar.reinvestDate) }}</td>
                  <td class="text-center">{{ ar.fundingSourceType }}</td>
                  <td class="text-center">
                    <span class="label label-warning" v-if="ar.status === 'PENDING'">Pending</span>
                    <span class="label label-info" v-if="ar.status === 'FUNDS_TRANSFERRED'">Funds Transferred</span>
                    <span class="label label-success" v-if="ar.status === 'PROCESSED'">Processed</span>
                    <span class="label label-danger" v-if="ar.status === 'CANCELLED'">Cancelled</span>
                    <span class="label label-danger" v-if="ar.status === 'FAILED'">Failed</span>
                  </td>
                  <td class="text-center">
                    <button
                      v-if="ar.status === 'PENDING'"
                      type="button"
                      class="btn btn-danger btn-sm"
                      :disabled="cancellingReinvestmentId === ar.id"
                      @click="confirmCancelReinvestment(ar)"
                    >
                      {{ cancellingReinvestmentId === ar.id ? 'Cancelling...' : 'Cancel' }}
                    </button>
                    <span v-if="ar.status === 'FUNDS_TRANSFERRED'" class="text-muted">
                      Transfer in progress
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row top-margin">
            <div class="col-md-12">
              <button type="button" class="btn btn-default btn-lg" @click="openAddAdditionalReinvestmentModal">
                <em class="fa fa-plus"></em> Add Additional Reinvestment
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="line-separator"></div>

      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-12 subtitle">
              <div class="panel-heading">
                <h3 class="panel-title"><em class="fa fa-exchange text-blue"></em>Transactions you need to provide direction on</h3>
              </div>
            </div>


          </div>
          <div v-if="!isThereAnyUpcomingTransactionWithNoAction()">
            <div class="row top-margin">
              <div class="col-md-12">
                <p class="no-transactions">
                  No transactions at the moment.
                </p>
                <br/><br/><br/>
              </div>
            </div>
          </div>

          <div v-if="isThereAnyUpcomingTransactionWithNoAction()">
            <div v-for="(nt, index) in notesTransactionsWithNoAction" :key="index">
              <div id="panelDemo1" class="panel panel-default">
                <div class="panel-heading top-margin">
                  <div class="panel-title">
                    Transaction {{ nt.transaction.transactionId }}
                  </div>
                </div>
                <div class="row notification">
                  <div class="col-md-12">
                    <div role="alert" class="alert alert-info">
                      <p><em class="icon icon-info pr-sm"></em>{{ getHeaderMessage() }} <strong>{{ getAlertMessage(nt) }}</strong>
                        on {{ formatDate(nt.transaction.maturityDate) }}.</p>
                      <p>Please note that you're able to change this payment using the options below.</p>
                    </div>
                  </div>
                </div>
                <div class="row transation-info">
                  <div class="col-md-6">
                    <div class="row first-row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Transaction date:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{ formatDate(nt.transaction.maturityDate) }}</label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Note number:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{ nt.transaction.note.noteId }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="row first-row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Payment type:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{getTypeOfPayment(nt.transaction.type)}}</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Amount:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{ formatAmount(nt.transaction.amount) }}</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="line-separator top-margin"></div>
                  </div>
                </div>
                <div class="transation-reinvest">
                  <div class="row">
                    <div class="col-md-6 left-padding">
                      <label class="value">Select from options below</label>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isReinvestActionTaken(nt.action)">
                      <label class="value">Rate and term</label>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isDonateActionTaken(nt.action)">
                      <label class="value">Donation amount</label>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isCashoutActionTaken(nt.action)">
                      <label class="value">Select bank account</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 left-padding">
                      <select v-model="nt.action" @change="actionChanged(nt.action, index, false)" name="action" class="form-control input-lg" required>
                        <option v-for="(action, index) in getActionsAllowedForThisTransaction()" :value="action" :key="index">{{action.text}} </option>
                      </select>
                    </div>

                    <div v-if="isReinvestActionTaken(nt.action)">
                      <CustomRateAndTerm
                        :manageRateAndTermGroupsId="nt.transaction.manageRateAndTermGroupsId"
                        :mainContainer="'left-padding'"
                        :term="nt.term"
                        :rate="nt.rate"
                        :nt="nt"
                        :rateLimit="investmentsRestrictions.rateLimit"
                        @rateAndTermIsInvalid="setRateAndTermAsInvalid(index, 'no-action')"
                        @rateAndTermIsValid="setRateAndTermAsValid(index, 'no-action')"
                        @rateChanged="setRate($event, index, 'no-action')"
                        @termChanged="setTerm($event, index, 'no-action')" />
                    </div>

                    <div class="col-md-6 left-padding" v-if="isDonateActionTaken(nt.action)">
                      <input v-model="nt.amountForDonation"
                             :disabled="true" class="form-control input-lg" required></input>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isCashoutActionTaken(nt.action)">
                      <select v-model="nt.fundingSource" name="fundingSource" class="form-control input-lg" required>
                        <option disabled hidden v-if="fs.removed" v-for="(fs, index) in fundingSources" :value="fs" :key="index">{{fs.name}}</option>
                        <option v-if="!fs.removed" v-for="(fs, index) in fundingSources" :value="fs" :key="index">{{fs.name}}</option>
                      </select>

                      <span v-if="shouldSubmitButtonBeDisabled(index, 'no-action')" class="error-feedback">
                        Please choose a bank account above or add one using the <a href @click.prevent="goToFundingSourcesSegment">bank account section</a>
                      </span>
                    </div>
                  </div>


                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-default btn-lg"
                            :disabled="submitsDisabled || shouldSubmitButtonBeDisabled(index, 'no-action')"
                            @click="submitUpcomingTransaction(nt)">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 subtitle">
              <div class="panel-heading">
                <h3 class="panel-title"><em class="fa fa-exchange text-gray"></em>Transactions you've provided direction on</h3>
              </div>
            </div>


          </div>
          <div v-if="!isThereAnyUpcomingTransactionWithAction()">
            <div class="row top-margin">
              <div class="col-md-12">
                <p class="no-transactions">
                  No transactions at the moment.
                </p>
              </div>
            </div>
          </div>

          <div v-if="isThereAnyUpcomingTransactionWithAction()">
            <div v-for="(nt, index) in notesTransactionsWithAction" :key="index">
              <div id="panelDemo1" class="panel panel-default">
                <div class="panel-heading top-margin">
                  <div class="panel-title">
                    Transaction {{ nt.transaction.transactionId }}
                  </div>
                </div>
                <div class="row notification">
                  <div class="col-md-12">
                    <div role="alert" class="alert alert-success">
                      <p><em class="icon-check pr-sm"></em>You have chosen to <strong>{{ getAlertMessage(nt) }}</strong>
                        on {{ formatDate(nt.transaction.maturityDate) }}.</p>
                      <p>Please note that you're able to change this payment using the options below.</p>
                    </div>
                  </div>
                </div>
                <div class="row transation-info">
                  <div class="col-md-6">
                    <div class="row first-row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Transaction date:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{ formatDate(nt.transaction.maturityDate) }}</label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Note number:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{ nt.transaction.note.noteId }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="row first-row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Payment type:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{getTypeOfPayment(nt.transaction.type)}}</label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 left-padding">
                        <label class="title">Amount:</label>
                      </div>

                      <div class="col-md-6 left-padding">
                        <label class="value">{{ formatAmount(nt.transaction.amount) }}</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="line-separator top-margin"></div>
                  </div>
                </div>

                <div class="transation-reinvest">
                  <div class="row">
                    <div class="col-md-6 left-padding">
                      <label class="value">Select from options below</label>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isReinvestActionTaken(nt.action)">
                      <label class="value">Rate and term</label>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isDonateActionTaken(nt.action)">
                      <label class="value">Donation amount</label>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isCashoutActionTaken(nt.action)">
                      <label class="value">Select bank account</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 left-padding">
                      <select v-model="nt.action" @change="actionChanged(nt.action, index, true)" name="action" class="form-control input-lg" required>
                        <option v-for="(action, index) in getActionsAllowedForThisTransaction()" :value="action" :key="index">{{action.text}}</option>
                      </select>
                    </div>

                    <div v-if="isReinvestActionTaken(nt.action)">
                      <CustomRateAndTerm
                        :manageRateAndTermGroupsId="nt.transaction.manageRateAndTermGroupsId"
                        :mainContainer="'left-padding'"
                        :term="nt.term"
                        :rate="nt.rate"
                        :nt="nt"
                        :rateLimit="investmentsRestrictions.rateLimit"
                        @rateAndTermIsInvalid="setRateAndTermAsInvalid(index, 'action')"
                        @rateAndTermIsValid="setRateAndTermAsValid(index, 'action')"
                        @rateChanged="setRate($event, index, 'action')"
                        @termChanged="setTerm($event, index, 'action')" />
                    </div>


                    <div class="col-md-6 left-padding" v-if="isDonateActionTaken(nt.action)">
                      <input v-model="nt.amountForDonation"
                              :disabled="true" class="form-control input-lg" required></input>
                    </div>

                    <div class="col-md-6 left-padding" v-if="isCashoutActionTaken(nt.action)">
                      <select v-model="nt.fundingSource" name="fundingSource" class="form-control input-lg" required>
                        <option disabled hidden v-if="fs.removed" v-for="(fs, index) in fundingSources" :value="fs" :key="index">{{fs.name}}</option>
                        <option v-if="!fs.removed" v-for="(fs, index) in fundingSources" :value="fs" :key="index">{{fs.name}}</option>
                      </select>

                      <span v-if="shouldSubmitButtonBeDisabled(index, 'action')" class="error-feedback">
                        Please choose a bank account above or add one using the <a href @click.prevent="goToFundingSourcesSegment">bank account section</a>
                      </span>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-default btn-lg"
                      :disabled="submitsDisabled || shouldSubmitButtonBeDisabled(index, 'action')"
                      @click="submitUpcomingTransaction(nt)">Submit</button>
                  </div>
                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>

    <AddAdditionalReinvestment
      :isVisible="showAdditionalReinvestmentModal"
      :availableNoteIds="getAvailableNoteIds()"
      :fundingSources="availableFundingSources"
      @close="closeAddAdditionalReinvestmentModal"
      @save="saveAdditionalReinvestment"
    />

  </div>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import { find } from 'lodash';

  import {
    VMoney,
  } from 'v-money';


  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
  } from '@/store/mutation-types';

  import Errors from '@/components/modals/Errors';
  import { Events } from '@/data/static/events';
  import spinner from '@/components/widgets/Spinner';
  import DismissableAlert from '@/components/widgets/DismissableAlert';
  import CustomRateAndTerm from '@/components/CustomRateAndTerm';
  import AddAdditionalReinvestment from '@/components/modals/AddAdditionalReinvestment';

  import {
    convertErrorStringsToArrayStrings,
    findRates,
    formatAmount,
    formatDate,
    formatRate,
    formatTerm,
    isStateRestricted,
    setActionTakenUpcomingTransactionHelper,
    setFundingSourceUpcomingTransactionHelper,
    orderUpcomingTransactions,
  } from '@/util';

  import Actions from '@/data/static/upcomingTransactionActions'; // eslint-disable-line no-unused-vars
  import TransactionTypes from '@/data/static/transactionTypes'; // eslint-disable-line no-unused-vars
  import TransactionStatuses from '@/data/static/transactionStatuses'; // eslint-disable-line no-unused-vars

  import {
    Constants,
  } from '../data/static/constants';

  const mix = {
    methods: {
      formatDate,
      formatAmount,
      formatRate,
      formatTerm,
      isStateRestricted,
      findRates,
    },
  };

  export default {
    name: 'upcomingTransactions',
    async beforeMount() {
      await this.initializeState();
      this.loadInvestmentsValidations();
      this.setActiveAccountIndex();
    },
    props: [
      'accountId', 'defaultFundingSourceId', 'investorAccountIdentifier',
    ],
    mixins: [mix],
    components: {
      errors: Errors,
      'dismissable-alert': DismissableAlert,
      spinner,
      CustomRateAndTerm,
      AddAdditionalReinvestment,
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('transaction', [
        'loading',
      ]),
      ...mapState('transaction', [
        'loading',
      ]),
      ...mapState('app', [
        'user',
        'fundingSourceTypes',
        'investmentsRestrictions',
        'activeAccountId',
      ]),
      isExtraReinvestmentsEnabled() {
        return true;
      },
      hasAdditionalReinvestments() {
        return this.additionalReinvestments !== null
          && this.additionalReinvestments.length > 0;
      },
      isShowingReinvestmentNotice() {
        return (this.notesTransactionsWithAction !== null
          && this.notesTransactionsWithAction.length > 0)
          || (this.notesTransactionsWithNoAction !== null
          && this.notesTransactionsWithNoAction.length > 0);
      },
      availableFundingSources() {
        return [
          {
            name: this.fundingSourceTypes.CHECK.label,
            type: this.fundingSourceTypes.CHECK.name,
          },
          {
            name: this.fundingSourceTypes.WIRE_TRANSFER.label,
            type: this.fundingSourceTypes.WIRE_TRANSFER.name,
          },
        ];
      },
    },
    data() {
      return {
        actions: Actions,
        yearRates: [],
        fundingSources: [],
        dwollaTermsUrl: Constants.purchaseNote.dwollaTermsUrl,
        prospectusTermUrl: Constants.purchaseNote.prospectusTermUrl,
        notesTransactionsWithNoAction: null,
        notesTransactionsWithAction: null,
        additionalReinvestments: [],
        minimumInvestmentAmount: null,
        submitsDisabled: false,
        initializingState: false,
        showAdditionalReinvestmentModal: false,
        cancellingReinvestmentId: null,
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false,
        },
        activeAccountIndex: 0,
      };
    },
    methods: {
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapActions('account', [
        'getAccountTransactions',
        'getAccountFundingSources',
        'getAccountExtraReinvestments',
        'createAccountExtraReinvestment',
        'cancelAccountExtraReinvestment',
      ]),
      ...mapActions('note', [
        'getInterestYearRates',
      ]),
      ...mapActions('transaction', [
        'getUpcomingTransactions',
        'updateUpcomingTransaction',
      ]),
      setActiveAccountIndex() {
        const activeAccount = this.user.accounts.find(ac => ac.id === this.activeAccountId);
        this.activeAccountIndex = this.user.accounts.indexOf(activeAccount);
      },
      determineIfNotificationShouldBeDisplayed() {
        if (this.notesTransactionsWithNoAction.length > 0) {
          this.$emit(Events.SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_NO_ACTION);
        } else if (this.notesTransactionsWithAction.length > 0) {
          this.$emit(Events.SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_ACTION);
        } else {
          this.$emit(Events.HIDE_ALERT_FOR_UPCOMING_TRANSACTIONS);
        }
      },
      async initializeState() {
        try {
          this.$emit(Events.UPCOMING_TRANSACTIONS_LOADING_STARTED);
          const fundingSources = await this.getAccountFundingSources(this.accountId);

          this.fundingSources = fundingSources.filter(fss => fss.status === 'verified' &&
            (fss.type === this.fundingSourceTypes.BANK.name ||
              fss.type === this.fundingSourceTypes.CHECK.name ||
              fss.type === this.fundingSourceTypes.WIRE_TRANSFER.name));

          this.yearRates = this.investmentsRestrictions.ratesAndTerms;

          const accountTransactions = await this.getAccountTransactions(
            {
              accountId: this.accountId,
              params: {
                transactionTypes: [
                  TransactionTypes.SELL_REINVEST,
                  TransactionTypes.SELL_DONATE,
                  TransactionTypes.SELL_MATURE,
                  TransactionTypes.INT_REINVEST,
                  TransactionTypes.INT_PAID,
                  TransactionTypes.INT_DONATE,
                ],
                statuses: [TransactionStatuses.PREPENDING],
              },
            });
          this.buildNotesTransactionsObjects(accountTransactions);
          await this.loadAdditionalReinvestments();
          this.determineIfNotificationShouldBeDisplayed();
          this.$emit(Events.UPCOMING_TRANSACTIONS_LOADING_SUCCEED);
        } catch (error) {
          this.$emit(Events.UPCOMING_TRANSACTIONS_LOADING_FAILED);
          this.setErrorsModalInfo(['Something went wrong. Please try reloading the website.']);
          this.showErrorsModal();
          this.initializingState = false;
        }
      },
      showStateRestrictionMessage() {
        const state = this.user.residentialAddress.state;
        return this.isStateRestricted(state);
      },
      isThereAnyUpcomingTransactionWithNoAction() {
        return this.notesTransactionsWithNoAction !== null
          && this.notesTransactionsWithNoAction.length > 0;
      },
      loadInvestmentsValidations() {
        this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
      },
      isThereAnyUpcomingTransactionWithAction() {
        return this.notesTransactionsWithAction !== null
          && this.notesTransactionsWithAction.length > 0;
      },
      getHeaderMessage() {
        return 'According to your default preference your money will be';
      },
      getAlertMessage(upcomingTransaction) {
        const { type, actionTaken } = upcomingTransaction.transaction;
        const isActionTaken = actionTaken !== undefined && actionTaken !== null;
        if (type === TransactionTypes.INT_PAID || type === TransactionTypes.SELL_MATURE) {
          return (isActionTaken ? 'repay account' : 'repaid');
        } else if (type === TransactionTypes.INT_DONATE || type === TransactionTypes.SELL_DONATE) {
          return (isActionTaken ? 'donate to Calvert Impact Capital'
          : 'donated to Calvert Impact Capital');
        }
        return (isActionTaken ? 'reinvest in a new note' : 'reinvested in a new note');
      },
      goToFundingSourcesSegment() {
        this.$emit(Events.GO_TO_FUNDING_SOURCES_SEGMENT);
      },
      buildNotesTransactionsObjects(transactions) {
        const {
          transactionsWithActionTaken, transactionsWithoutActionTaken,
        } = transactions.reduce((acc, t) => {
          const {
            actionTaken,
            amount,
            fundingSourceId,
            note,
            rate,
            term,
            type,
          } = t;

          const action = setActionTakenUpcomingTransactionHelper(actionTaken, type);

          let newRate = rate;
          let newTerm = term;

          if (
            action &&
            action.name === Actions.reinvest.name &&
            !term
            ) {
            const interestTerm = term !== 0 ? term : note.interestTerm;
            const interestRate = rate !== 0 ? rate : note.interestRate;

            const interestYearRatesSelectedPreviously = findRates(
                          this.yearRates,
                          interestTerm,
                          interestRate,
                          true,
                    );
            newRate = interestYearRatesSelectedPreviously.rate;
            newTerm = interestYearRatesSelectedPreviously.term;
          }

          const fundingSource =
          setFundingSourceUpcomingTransactionHelper(
            action,
            fundingSourceId,
            this.defaultFundingSourceId.toString(),
            this.fundingSources,
          );

          const transactionObject = {
            action,
            transaction: t,
            fundingSource,
            amountForDonation: formatAmount(amount),
            rate: newRate,
            term: newTerm,
            isRateAndTermValid: false,
          };

          if (!actionTaken) {
            acc.transactionsWithoutActionTaken.push(transactionObject);
          } else {
            acc.transactionsWithActionTaken.push(transactionObject);
          }

          return acc;
        }, {
          transactionsWithActionTaken: [],
          transactionsWithoutActionTaken: [],
        });

        this.notesTransactionsWithAction =
            orderUpcomingTransactions(transactionsWithActionTaken);
        this.notesTransactionsWithNoAction =
            orderUpcomingTransactions(transactionsWithoutActionTaken);

        return {
          transactionsWithActionTaken: this.notesTransactionsWithAction,
          transactionsWithoutActionTaken: this.notesTransactionsWithNoAction,
        };
      },
      setRate(newRate, index, type) {
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        noteTransaction.rate = newRate;
      },
      setTerm(newTerm, index, type) {
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        noteTransaction.term = newTerm;
      },
      setRateAndTermAsInvalid(index, type) {
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        noteTransaction.isRateAndTermValid = false;
      },
      setRateAndTermAsValid(index, type) {
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        noteTransaction.isRateAndTermValid = true;
      },
      getActionsAllowedForThisTransaction() {
        return this.notesTransactionsWithNoAction.concat(this.notesTransactionsWithAction)
          .reduce((acc, val) => acc + val.transaction.amount, 0) >= this.minimumInvestmentAmount
          ? [Actions.reinvest, Actions.donate, Actions.cashout]
          : [Actions.donate, Actions.cashout];
      },
      isCashoutActionTaken(action) {
        return action.name === Actions.cashout.name;
      },
      isDonateActionTaken(action) {
        return action.name === Actions.donate.name;
      },
      isReinvestActionTaken(action) {
        return action.name === Actions.reinvest.name;
      },
      getTypeOfPayment(type) {
        return (type === TransactionTypes.INT_PAID ||
          type === TransactionTypes.INT_DONATE ||
          type === TransactionTypes.INT_REINVEST) ? 'Interest payment' : 'Principal payment';
      },
      shouldSubmitButtonBeDisabled(index, type) { // eslint-disable-line
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        const { action } = noteTransaction;
        if (action.name === Actions.cashout.name) {
          return noteTransaction.fundingSource === undefined
            || noteTransaction.fundingSource === null;
        } else if (action.name === Actions.reinvest.name) {
          return !noteTransaction.isRateAndTermValid;
        }
        return false;
      },
      actionChanged(action, index, actionPreviousTaken) {
        const upcomingTransaction = actionPreviousTaken ? this.notesTransactionsWithAction[index]
          : this.notesTransactionsWithNoAction[index];

        upcomingTransaction.fundingSource = null;
        upcomingTransaction.interestRateAndTerm = null;

        if (action.name === Actions.cashout.name) {
          upcomingTransaction.fundingSource =
            find(this.fundingSources, fs =>
              fs.id.toString() === this.defaultFundingSourceId.toString());
        } else if (action.name === Actions.reinvest.name) {
          const { note, term } = upcomingTransaction.transaction;
          const interestTerm = term !== 0 && term ? term : note.interestTerm;
          const interestYearRatesSelectedPreviously = findRates(this.yearRates,
            interestTerm, note.interestRate);
          upcomingTransaction.rate = interestYearRatesSelectedPreviously.rate;
          upcomingTransaction.term = interestYearRatesSelectedPreviously.term;
        }
      },
      submitUpcomingTransaction(noteTransaction) {
        this.$emit(Events.UPCOMING_TRANSACTIONS_LOADING_STARTED);
        this.submitsDisabled = true;

        const {
          action,
          fundingSource,
          rate,
          term,
          transaction,
        } = noteTransaction;

        const upcomingTransactionToUpdate = {
          actionTaken: action.name,
          fundingSourceId: fundingSource ? String(fundingSource.id) : '',
          term: (this.isReinvestActionTaken(action) ? term : -1),
          rate: (this.isReinvestActionTaken(action) ? rate : -1),
          termsOfConditionAcceptance: true,
        };

        this.updateUpcomingTransaction({
          payload: upcomingTransactionToUpdate,
          transactionId: transaction.id,
        })
        .then(async () => {
          await this.initializeState();
          this.submitsDisabled = false;
        })
        .catch((errors) => {
          this.$emit(Events.UPCOMING_TRANSACTIONS_LOADING_FAILED);
          this.setErrorsModalInfo(convertErrorStringsToArrayStrings(errors.message));
          this.showErrorsModal();
          this.submitsDisabled = false;
        });
        this.resetComponent();
      },
      resetComponent() {
        Object.assign(this.$data, this.$options.data.call(this));
      },
      isAValidTerm(index, type) {
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        const { customTerm, addCustomRateAndTerm } = noteTransaction;

        if (!addCustomRateAndTerm) {
          noteTransaction.termErrorMessage = '';
          return true;
        }

        if (customTerm < 1 || (customTerm % 0.25) !== 0) {
          noteTransaction.termErrorMessage = 'Years must be a positive number greater than 1 in multiples of .25';
          return false;
        }

        return true;
      },
      isAValidRate(index, type) {
        const noteTransaction = (type === 'no-action') ?
          this.notesTransactionsWithNoAction[index]
          :
          this.notesTransactionsWithAction[index];

        const { customRate, addCustomRateAndTerm } = noteTransaction;

        if (!addCustomRateAndTerm) {
          noteTransaction.rateErrorMessage = '';
          return true;
        }

        if (customRate < 0) {
          noteTransaction.rateErrorMessage = 'Negative numbers are not allowed';
          return false;
        }

        if (customRate > this.investmentsRestrictions.rateLimit) {
          noteTransaction.rateErrorMessage =
            `The maximum allowed rate is ${formatRate(this.investmentsRestrictions.rateLimit)}`;
          return false;
        }
        return true;
      },
      async loadAdditionalReinvestments() {
        try {
          const response = await this.getAccountExtraReinvestments(this.accountId);
          this.additionalReinvestments = response || [];
        } catch (error) {
          console.error('Error loading additional reinvestments:', error);
          this.additionalReinvestments = [];
        }
      },
      openAddAdditionalReinvestmentModal() {
        this.showAdditionalReinvestmentModal = true;
      },
      closeAddAdditionalReinvestmentModal() {
        this.showAdditionalReinvestmentModal = false;
      },
      getAvailableNoteIds() {
        const allTransactions = [
          ...(this.notesTransactionsWithAction || []),
          ...(this.notesTransactionsWithNoAction || []),
        ];

        if (allTransactions.length === 0) {
          return [];
        }

        return allTransactions
          .filter(nt => nt.action && nt.action.name === Actions.reinvest.name)
          .map(nt => ({
            noteId: nt.transaction.note.noteId,
            label: `Note ${nt.transaction.note.noteId}`,
          }))
          .filter((item, index, self) =>
            index === self.findIndex(t => t.noteId === item.noteId),
          );
      },
      async saveAdditionalReinvestment(additionalReinvestment) {
        try {
          const payload = {
            amount: additionalReinvestment.amount,
            noteId: additionalReinvestment.noteId,
            fundingSourceType: additionalReinvestment.fundingSourceType,
          };
          if (additionalReinvestment.fundingSourceId) {
            payload.fundingSourceId = additionalReinvestment.fundingSourceId;
            payload.fundingSourceName = additionalReinvestment.fundingSourceName;
          }
          await this.createAccountExtraReinvestment({
            accountId: this.accountId,
            payload,
          });

          await this.loadAdditionalReinvestments();
        } catch (error) {
          console.error('Error saving additional reinvestment:', error);
          this.setErrorsModalInfo(['Error saving additional reinvestment. Please try again.']);
          this.showErrorsModal();
        } finally {
          this.closeAddAdditionalReinvestmentModal();
        }
      },
      async confirmCancelReinvestment(reinvestment) {
        // eslint-disable-next-line no-alert
        if (!window.confirm(`Are you sure you want to cancel this reinvestment of ${formatAmount(reinvestment.amount)}?`)) {
          return;
        }
        this.cancellingReinvestmentId = reinvestment.id;
        try {
          await this.cancelAccountExtraReinvestment({
            accountId: this.accountId,
            extraReinvestmentId: reinvestment.id,
          });
          await this.loadAdditionalReinvestments();
        } catch (error) {
          this.setErrorsModalInfo(['Error cancelling reinvestment. Please try again.']);
          this.showErrorsModal();
        } finally {
          this.cancellingReinvestmentId = null;
        }
      },
    },

    directives: { money: VMoney },
  };
</script>

<style scoped>
  .content-heading {
    font-weight: normal;
  }
  .panel-default {
    padding: 20px 30px;
  }
  .panel-heading {
    color: #444;
    background-color: #ffffff;
    border-color: #cfdbe2;
    border-bottom: 0;
    padding: 0;
  }
  .alert {
    padding: 20px 10px 20px 10px;
  }
  label.title {
    color: #909FA6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  label.value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  select, input {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 40px;
  }
  .notification {
    margin-top: 20px;
  }
  .transation-info {
    margin: 20px 0px 20px 0px;
  }
  .transation-reinvest {
    margin: 10px 20px 10px 20px;
  }
  .transaction-subtitle {
    margin-top: 20px;
  }
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .top-margin {
    margin-top: 2%;
  }
  .term-error-message {
    padding-left: 20px;
  }
  .bottom-margin {
    margin-bottom: 5px;
  }
  .left-padding {
    padding-left: 0;
  }
  .subtitle {
    margin: 7px 0 7px 0;
    color: #817E7D;
  }
  .first-row {
    margin-bottom: 10px;
  }
  .checkbox {
    margin-bottom: 15px;
    margin-left: 5px;
  }
  .btn {
    margin-left: 5px;
  }
  .no-transactions {
    color: #F78A0E;
  }
  .hyperlink {
    color: #f05050;
    text-decoration: underline;
  }
  .text-blue {
    color: #23b7e5;
  }
  .panel-title .fa {
    margin-right: 10px;
  }
  .panel .panel .panel-title {
    margin-bottom: 15px;
    font-size: 16px;
  }
  .checkbox {
    margin-left: 10px;
  }
  .c-checkbox span,
  .c-radio span {
    margin-left: -28px;
  }
  .col-md-2 .form-group > span {
    display: block;
    padding-top: 12px;
  }
  .additional-reinvestments-table {
    border-collapse: collapse;
  }
  .additional-reinvestments-table th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }
  .additional-reinvestments-table td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .additional-reinvestments-table.table-striped > tbody > tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }
</style>



// WEBPACK FOOTER //
// UpcomingTransactions.vue?27be3374